import './SeasonList.scss';

import * as React from 'react';
import { connect } from 'react-redux';
import SeasonComponent from 'src/components/Season/Season';
import LoadingSpinner from 'src/components/utils/LoadingSpinner/LoadinSpinner';
import WeekList from 'src/components/Week/WeekList/WeekList';
import { ApplicationState } from 'src/store';
import { getSeasons, toggleSeason } from 'src/store/season/actions';
import { ISeasonData } from 'src/store/season/types';
import { Section } from 'src/store/sections/types';

/*
{(section.view === ViewType.Weekly ? (
                    <WeekList season={season} section={section} />
                   ) : (
                   <EventList season={season} sectionTitle={section.title} />
                  ))}
*/

interface PropsFromState {
  loading: boolean;
  seasonData: ISeasonData;
  error?: Error;
}

interface PropsFromDispatch {
  getSeasons: typeof getSeasons;
  toggleSeason: typeof toggleSeason;
}

interface Props {
  section: Section;
}

type AllProps = PropsFromState & PropsFromDispatch & Props;

class SeasonList extends React.Component<AllProps> {
  public componentDidMount() {
    const bySection = this.props.seasonData.bySectionTitle[this.props.section.title];
    if (!bySection || bySection.length <= 0) {
      this.props.getSeasons(this.props.section.title);
    }
    console.log(this.props.seasonData.bySectionTitle);
  }

  public render() {
    const { seasonData, section, loading } = this.props;
    const seasonIds = seasonData.bySectionTitle[section.title];

    return (
      <div className="season-list">
        <LoadingSpinner pending={loading} />
        {seasonIds &&
          seasonIds.map((id: number, index: number) => {
            const season = seasonData.byId[id];

            return (
              <div className={`season ${season.selected ? 'open' : ''}`} key={index}>
                <SeasonComponent season={season} section={section} />
                {season.selected && <WeekList season={season} section={section} />}
              </div>
            );
          })}
      </div>
    );
  }
}

const mapStateToProps = ({ season }: ApplicationState) => ({
  loading: season.loading,
  seasonData: season.data,
  error: season.errors
});

const mapDispatchToProps = (dispatch: any) => ({
  getSeasons: (sectionTitle: string) => dispatch(getSeasons(sectionTitle)),
  toggleSeason: (sectionTitle: string, id: number) => dispatch(toggleSeason(sectionTitle, id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SeasonList);



// WEBPACK FOOTER //
// ./src/components/Season/SeasonList/SeasonList.tsx